import { isEmpty, isNil, mergeRight, prop, propOr } from 'ramda';
import { api, setter, fetchParams, fetchResponse } from '@/modules/helper';
import { stripExtensionCode } from '@/utils/helper';

export default {
  namespaced: true,

  state: {
    items: [],
    user: {},
    pagination: {
      skip: 0,
      limit: 10,
    },
  },

  mutations: {
    dynamicSet: setter,
  },

  getters: {
    items: prop('items'),
    user: prop('user'),
    pagination: prop('pagination'),
  },

  actions: {
    create(state, payload) {
      return api.post('user', payload);
    },

    update(state, payload) {
      return api.patch(`user/${payload.id}`, payload);
    },

    updatePassword(state, payload) {
      return api.patch(`user/password/${payload.id}`, payload);
    },

    fetch({ commit, state }, payload) {
      const hardFetch = propOr(false, 'hardFetch', payload);
      const shop_id = propOr([], 'shop_id', payload);

      if (isEmpty(state.items) || hardFetch) {
        return api
          .get('user', {
            params: fetchParams(state, payload, {
              shop_id: shop_id.filter(id => !isNil(id)),
            }),
          })
          .then(data => commit('dynamicSet', fetchResponse(data)))
          .catch(error => error);
      }
    },

    exportData({ state }, payload) {
      const shop_id = propOr([], 'shop_id', payload);
      const params = fetchParams(state, payload, {
        shop_id: shop_id.filter(id => !isNil(id)),
      });

      return api.get('user/export', {
        responseType: 'blob',
        params,
      });
    },

    find({ commit }, id) {
      return api
        .get(`user/${id}`)
        .then(({ data }) =>
          mergeRight(data, {
            mobile: stripExtensionCode(data.mobile),
          }),
        )
        .then(user => commit('dynamicSet', { user }));
    },

    remove({ dispatch }, id) {
      return api.delete(`user/${id}`).then(() => dispatch('fetch'));
    },

    reactivate({ dispatch }, id) {
      return api.patch(`user/reactivate/${id}`).then(() => dispatch('fetch'));
    },
  },
};
